<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group">
    <label for="active_type">{{ $t('active_type') }}</label>
    <Combobox
      class="bg-white"
      :hasErrors="errors.has('active_type')"
      name='active_type'
      :placeholder="$t('select_a_item')"
      label="name"
      :options="activestypes"
      :initial-value="movementType.activeType"
      v-model="movementType.activeType"
      :reduce="activesTypes => activesTypes.id"
      v-validate="'required'"
    />

    <small v-show="errors.has('active_type')" class="form-text">
      {{ errors.first('active_type') }}
    </small>
  </div>

  <div class="form-group" :class="{ 'has-error': errors.has('type') }">
    <label for="type">{{ $t('type') }}</label>
    <input
      :disabled="!movementType.activeType"
      type="text"
      id="type"
      name="type"
      class="form-control"
      :placeholder="$t('ph_movement_type')"
      v-model="movementType.name"
      v-validate="'required'"
      @input="movementType.name = movementType.name.toUpperCase()"
    >
    <small v-show="errors.has('type')" class="form-text text-muted">
      {{ errors.first('type') }}
    </small>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="save"
        :loading="isLoading"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'MovementTypeForm',
  components: {
    LoaderButton,
    Combobox
  },

  props: {
    movementType: {
      type: Object,
      default: () => ({
        id: undefined,
        name: '',
        activeType: undefined
      })
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      isLoading: state => state.movementtype.isLoading
    })
  },

  methods: {
    ...mapActions('movementtype', [
      'create',
      'edit',
      'cleanState'
    ]),

    async save (evt, done) {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }
      const { id, activeType } = this.movementType

      if (typeof activeType === 'object') {
        this.movementType.activeType = activeType.id
      }

      const result = id
        ? await this.edit({ id, data: this.movementType })
        : await this.create(this.movementType)

      if (result) {
        this.$router.push({ name: 'listmovementtype' })
      }
    }
  },

  mounted () {
    this.$store.dispatch('activestype/fetchAll')
  },

  destroyed () {
    this.cleanState()
  }
}
</script>